/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PackJson model module.
 * @module model/PackJson
 * @version v1
 */
export class PackJson {
  /**
   * Constructs a new <code>PackJson</code>.
   * @alias module:model/PackJson
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PackJson</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PackJson} obj Optional instance to populate.
   * @return {module:model/PackJson} The populated <code>PackJson</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PackJson();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
PackJson.prototype.id = undefined;

/**
 * @member {String} name
 */
PackJson.prototype.name = undefined;

